import React, { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';
import { Box, useTheme } from '@mui/material';

const MermaidRenderer = ({ chart }: { chart: string }) => {
  const theme = useTheme();
  const containerRef = useRef<HTMLDivElement>(null);
  const graphRef = useRef<HTMLDivElement>(null);
  const [graphWidth, setGraphWidth] = useState('800px');
  const [hasError, setHasError] = useState(false);

  const themeVariables = {
    primaryColor: theme.palette.primary.main,
    primaryTextColor: theme.palette.common.black,
    primaryBorderColor: theme.palette.error.main,
    lineColor: theme.palette.warning.main,
    secondaryColor: theme.palette.warning.main,
    tertiaryColor: theme.palette.error.main,
    fontFamily: theme.typography.fontFamily,
  };
  useEffect(() => {
    mermaid.initialize({
      startOnLoad: true,
      theme: ['mindmap'].includes(chart) ? 'default' : 'base',
      themeVariables: ['flowchart'].includes(chart) ? themeVariables : {},
      legacyMathML: true,
      securityLevel: 'loose',
    });

    // Wait for the Mermaid graph to render, then adjust width
    const renderMermaid = async () => {
      await mermaid.run();

      if (graphRef.current) {
        const actualWidth = graphRef.current.scrollWidth;
        setGraphWidth(`${actualWidth}px`);
      }
    };

    renderMermaid().catch((error) => {
      setHasError(true);
      console.error('Error rendering Mermaid chart:', error);
    });
  }, [chart]);

  if (hasError) {
    return <Box sx={{ color: theme.palette.text.primary }}>Error rendering chart</Box>;
  }

  return (
    <div ref={containerRef} style={{ overflowX: 'scroll', width: '100%' }}>
      <div ref={graphRef} className="mermaid" style={{ width: graphWidth }}>
        {chart}
      </div>
    </div>
  );
};

export default MermaidRenderer;
